module.exports = __webpack_public_path__ + "static/img/3areaA_1.f4b8477.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/タイラニャン/3areaA_1.png
// module id = 851
// module chunks = 1